import {
  auth,
  dealer,
  carList,
  geofences,
  groups,
  notices,
  journeys,
  pois,
  carView,
  support,
  lockbeat,
  rpms,
  connectionRequests,
  subscriptions,
  drivers,
  routeTasks,
  orders,
  serviceManager,
} from '.';

//Rollbar is a global variable, lint complains
//https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/template/README.md#using-global-variables
//const Rollbar = window.Rollbar;

const api = (action, ...params) => {
  const apis = {
    login: auth.login,
    currentUser: auth.currentUserPoolUser,
    currentSession: auth.currentSession,
    completeNewPassword: auth.completeNewPassword,
    changePassword: auth.changePassword,
    forgotPassword: auth.forgotPassword,
    forgotPasswordSubmit: auth.forgotPasswordSubmit,
    'dealer profile': dealer.get,
    'get cars': carList.get,
    'get cars minimal': carList.getMinimal,
    'get dashboard cars list': carList.getDashboardCarsList,
    'get dashboard cars filters': carList.getDashboardCarsFilters,
    'get dashboard cars map': carList.getDashboardCarsOnMap,
    'get dashboard': carList.getDashboard,
    'get cars filters': carList.getFilters,
    getCarPlates: carList.getPlates,
    'update car': carList.updateCar,
    getVehiclesGroups: groups.getGroups,
    'create group': groups.createGroup,
    'update group': groups.updateGroup,
    'add vehicles to group': groups.addGroupVehicles,
    'remove vehicles from group': groups.removeGroupVehicles,
    'delete group': groups.deleteGroup,
    'delete vehicle from group': groups.deleteGroupVehicle,
    'get all groups': groups.getAllGroups,
    'get groups count': groups.getCounts,
    getAllNotices: notices.getAll,
    getNotices: notices.getPerImei,
    getDetailPositions: notices.getDetailPositions,
    getCrashReport: notices.getCrashReport,
    'get all journeys': journeys.getAll,
    'get journeys': journeys.get,
    'get one day journeys': journeys.oneDay,
    'update journey': journeys.update,
    getAllPOI: pois.getAll,
    searchPOI: pois.search,
    addPOI: pois.add,
    deletePOI: pois.delete,
    historyDtc: carView.getDtcsHistory,
    historyAlarms: carView.getAlarmsHistory,
    historyMaintenance: carView.getMaintenancesHistory,
    supportRequest: support.supportRequest,
    getAllLockbeat: lockbeat.getAll,
    updateLockbeat: lockbeat.updateLockbeat,
    getCarCrashEvents: carView.getCrashEventsCount,
    getFuelVariations: carView.getFuelVariations,
    getFuelLevels: carView.getFuelLevels,
    'menage door': carView.doorAction,
    'menage engine': carView.engineAction,
    getDoorControlHistory: carView.getDoorControlHistory,
    getEngineControlHistory: carView.getEngineControlHistory,
    'notice confirm': notices.confirm,
    'notice discard': notices.discard,
    getCar: carView.getCar,
    getRpm: rpms.getAll,
    getOverRPMFuelTheftGeofence: notices.getOverRPMFuelTheftGeofence,
    getGeofenceNotifications: notices.getGeofences,
    noticesReadMany: notices.setReadMany,
    getCarsHavingPengingNoticesOverRpmAndFuelTheft: notices.getCarsHavingPengingNoticesOverRpmAndFuelTheft,
    getGeofences: geofences.getGeofences,
    getGeofenceAvailableVehicles: geofences.getGeofenceAvailableVehicles,
    getGeofenceVehicles: geofences.getGeofenceVehicles,
    getGeofence: geofences.getGeofence,
    createGeofence: geofences.createGeofence,
    updateGeofence: geofences.updateGeofence,
    deleteGeofence: geofences.deleteGeofence,
    'get connection requests': connectionRequests.getAllConnectionRequest,
    'delete connection request': connectionRequests.deleteAConnectionRequest,
    'getZuoraToken': connectionRequests.getZuoraToken,
    'getZuoraPaymentMethods': connectionRequests.getZuoraPaymentMethods,
    'subscribeToProducts': connectionRequests.subscribeToProducts,
    'setPaymentMethodDefault': connectionRequests.setPaymentMethodDefault,
    'getSlimpayIframe': connectionRequests.getSlimpayIframe,
    'getConnectionRequestFleetCustomerDetails': connectionRequests.getFleetCustomerDetails,
    'getConnectionRequestProducts': connectionRequests.getProducts,
    'getConnectionRequestDiscountProducts': connectionRequests.getDiscountProducts,
    'getConnectionRequestVehicleInfocarData': connectionRequests.getVehicleInfocarData,
    'getConnectionRequestVehicleTechnicalDetails': connectionRequests.getVehicleTechnicalDetails,
    'getConnectionRequestVehicleBrands': connectionRequests.getVehicleBrands,
    'getConnectionRequestVehicleModelsByBrandId': connectionRequests.getVehicleModelsByBrandId,
    'getConnectionRequestVehicleVariantsByModelId': connectionRequests.getVehicleVariantsByModelId,
    'postConnectionRequestRegisterVehicle': connectionRequests.postRegisterVehicle,
    getSubscriptions: subscriptions.getSubscriptions,
    createDisconnection: subscriptions.createDisconnection,
    removeDisconnection: subscriptions.removeDisconnection,
    downloadDocument: subscriptions.downloadDocument,
    'getDriversAll': drivers.getAll,
    'createDriver': drivers.create,
    'updateDriver': drivers.update,
    'deleteDriver': drivers.delete,
    'getRoutesTask': routeTasks.getAll,
    'createRoutesTask': routeTasks.createRoutesTask,
    'editRoutesTask': routeTasks.editRoutesTask,
    'deleteRoutesTask': routeTasks.deleteRoutesTask,
    'assignRoutesTask': routeTasks.assignRoutesTask,
    'unassignRoutesTask': routeTasks.unassignRoutesTask,
    'getOrders': orders.getAll,
    'getOrderAvailableVehicles': orders.getAvailableVehicles,
    'createOrder': orders.createOrder,
    'editOrder': orders.editOrder,
    'deleteOrder': orders.deleteOrder,
    'acceptOrder': orders.acceptOrder,
    'declineOrder': orders.declineOrder,
    'uploadOrderFile': orders.uploadOrderFile,
    'serviceManager profile': serviceManager.get,
  };

  try {
    return apis[action](...params);
  } catch (error) {
    console.error(`action: ${action} - error: ${error}`);
    //Rollbar.error(error);
    return Promise.reject(Object.assign({}, error, {severity: 'high'}));
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/services/api.js